import { inject, Injectable } from '@angular/core';
import {
  DefaultGearRepository,
  GearType,
  SOFTLINE_API_GARAGE_VEHICLE,
  SOFTLINE_API_GARAGE_VEHICLES,
  Vehicle,
} from '@softapps/werkstatt/garage-core';
import { ApiDataAccess } from '@softline/core';

@Injectable()
export class ToolRepository extends DefaultGearRepository<Vehicle> {
  constructor() {
    super(inject(ApiDataAccess), 'tool', {
      retrieve: SOFTLINE_API_GARAGE_VEHICLES,
      create: SOFTLINE_API_GARAGE_VEHICLES,
      retrieveById: SOFTLINE_API_GARAGE_VEHICLE,
      updateById: SOFTLINE_API_GARAGE_VEHICLE,
    });
  }
}
